import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const ChartBox: React.FC<{
  title?: string;
  children: React.ReactNode;
}> = ({ title, children }) => (
  <Box>
    <Typography
      sx={{
        fontWeight: 600,
        fontSize: 13,
        color: "#2e4734",
        mb: 0.5,
        textDecoration: "underline",
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);
